import { render, staticRenderFns } from "./rateTotal.vue?vue&type=template&id=4d61e2be&"
import script from "./rateTotal.vue?vue&type=script&lang=js&"
export * from "./rateTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports